export default __webpack_public_path__ + "static/media/avatar.342efd7d.svg";